import { storage } from '@/services/storage'

export const defaultOptionsUserGroups = (groups) => {
	const getUserT = (type) => storage.get(`label_${type}`)
	let list = []
	groups.forEach((item, index) => {
		list.push({
			id: index,
			label: getUserT(item),
			value: item,
			group: 'Perfis do Sistema'
		})
	})
	return list
}

export const selectUserList = (queue, groups) => {
	const types = [...defaultOptionsUserGroups(groups)]
	const multiple = []
	queue.forEach((item) => {
		types.forEach((type) => {
			if (type.value === item) {
				multiple.push(type)
			}
		})
	})
	return multiple
}

export const dafaultOptions = (options) => {
	let list = []
	options.forEach((item, index) => {
		list.push({
			id: index,
			label: item[0],
			value: item[1]
		})
	})
	return list
}

export const defaultOptionsTyped = (category) => {
	let list = []
	let id = 0
	category.forEach((item) => {
		item.options.forEach((option) => {
			list.push({
				id: id,
				label: option[0],
				value: option[1],
				type: item.type,
				disable: option.length > 2 ? option[2] : false
			})
			id++
		})
	})
	return list
}

export const loopList = (list, options) => {
	const multiple = []
	list.forEach((item) => {
		options.forEach((field) => {
			if (field.value === item) {
				multiple.push(field)
			}
		})
	})
	return multiple
}

export const setOptions = (list, options, value = 'value') => {
	const multiple = []
	list.forEach((item) => {
		options.forEach((field) => {
			if (field[value] === item) {
				multiple.push(field)
			}
		})
	})
	return multiple
}

export const selectOptions = (list, optionsList) => {
	const options = [...dafaultOptions(optionsList)]
	return loopList(list || [], options)
}

export const selectOptionsTyped = (list, optionsList) => {
	const options = [...defaultOptionsTyped(optionsList)]
	return loopList(list || [], options)
}
